import "./BrandLogo.css";

export default function BrandLogo({ src }) {
  const bundled = !src || /^\/logo\.jpg(?:[?#].*)?$/.test(src);
  return <img
    className={`app-brand-logo${bundled ? " app-brand-logo-bundled" : ""}`}
    src={bundled ? "/brand/alkeya-mobile-horizontal.png" : src}
    alt="Alkeya Mobile"
    width="960"
    height="300"
    loading="eager"
    decoding="async"
  />;
}
